import { gql } from "@apollo/client";

export const CREATE_MASTER_DATA_PRODUCT = gql`
  mutation CreateMasterDataProduct($params: CreateMasterDataProductInput!) {
    createMasterDataProduct(params: $params) {
      productId
      productKey
      itemName
      itemDescription
      upcItemNumber
      glItemNumber
      glItemDescription
      isActive
      categoryId
      categoryName
      categoryKey
      uomId
      uomCode
      uomName
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;

export const UPDATE_MASTER_DATA_PRODUCT = gql`
  mutation UpdateMasterDataProduct($params: UpdateMasterDataProductInput!) {
    updateMasterDataProduct(params: $params) {
      productId
      productKey
      itemName
      itemDescription
      upcItemNumber
      glItemNumber
      glItemDescription
      isActive
      categoryId
      categoryName
      categoryKey
      uomId
      uomCode
      uomName
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;
